import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardFooter from "components/Card/CardFooter.js";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Listfileuploaded from "components/Uploadfile/Chucnang/Listfileuploaded.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import axios from "axios";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const useStyles = makeStyles(styles);

const Capnhatvanban = React.memo(function Capnhatvanban(props) {
  const { vanban_id } = props;
  const classes = useStyles();
  const [sokyhieu, setSokyhieu] = React.useState("");
  const [ngayvanban, setNgayvanban] = React.useState(dayjs());
  const [trichyeu, setTrichyeu] = React.useState("");
  //const [loaivipham, setLoaivipham] = React.useState([]);
  //const [loaiviphamvalue, setLoaiviphamvalue] = React.useState(null);
  const [loaivanban, setLoaivanban] = React.useState([]);
  const [loaivanbanvalue, setLoaivanbanvalue] = React.useState(null);
  const [coquanbanhanh, setCoquanbanhanh] = React.useState([]);
  const [coquanbanhanhvalue, setCoquanbanhanhvalue] = React.useState(null);
  const [nguoiky, setNguoiky] = React.useState("");
  const [selectedFiles, setSelectedFiles] = React.useState(undefined);
  let [fileid, setFileid] = React.useState([]);
  let fileupload = new FormData();
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [alert3, setAlert3] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const [opensua, setOpensua] = React.useState(false);
  const handleClosesua = () => {
    setOpensua(false);
  };
  var username = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  const getvanbantheoid = () => {
    var url =
      Config.backend + "/api/QLVanBan/getvanbantheoid?vanban_id=" + vanban_id;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSokyhieu(data[0].sokyhieu);
        if (data[0].ngaybanhanh) {
          let [year1, month1, day1] = data[0].ngaybanhanh.split("/");
          setNgayvanban(dayjs(year1 + "/" + month1 + "/" + day1));
        }
        setTrichyeu(data[0].trichyeu);
        // setLoaiviphamvalue({
        //   id: data[0].loaivipham_id,
        //   ten: data[0].loaivipham_ten,
        // });
        setLoaivanbanvalue({
          id: data[0].loaivb_id,
          ten: data[0].loaivb,
        });
        setCoquanbanhanhvalue({
          id: data[0].coquanbanhanh_id,
          ten: data[0].coquanbanhanh,
        });
        if (data[0].nguoiky) setNguoiky(data[0].nguoiky);
        if (data[0].upload_id) {
          data.map((item) => {
            setFileid((oldArray) => [
              ...oldArray,
              { filename: item.name, id: item.upload_id },
            ]);
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
    setOpensua(false);
  };
  // const getloaivipham = () => {
  //   var url =
  //     Config.backend + "/api/Vipham/getdmloaivipham?username=" + username;
  //   fetch(url, obj)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setLoaivipham(data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data: ", error);
  //     });
  // };
  const getloaivanban = () => {
    var url =
      Config.backend + "/api/QLVanBan/getdmloaivanban?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaivanban(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcoquanbanhanh = () => {
    var url =
      Config.backend +
      "/api/donvi/getdonvitheoloaidonvi?dmloaidonvi_id=11&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCoquanbanhanh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const uploadFiles = () => {
    for (let i = 0; i < selectedFiles.length; i++) {
      fileupload.append("upload", selectedFiles[i]);
    }
    Uploadnewfile();
  };
  const xoafile = (id) => {
    setFileid([]);
    var url = Config.backend + "/api/QLVanBan/DeleteFile?fileId=" + id;
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          console.log("");
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
    showNotification2();
    setOpensua(true);
  };
  const capnhatvanban = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var ngayvb =
        ngayvanban.$y +
        "-" +
        String(ngayvanban.$M + 1).padStart(2, "0") +
        "-" +
        ngayvanban.$D;
      var url = Config.backend + "/api/QLVanBan/UpdateVanBan";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: vanban_id,
          soKyHieu: sokyhieu,
          ngayBanHanh: ngayvb,
          trichYeu: trichyeu,
          theLoaivanBanId: 2,
          //loaiviphamid: loaiviphamvalue.id,
          loaiVanBanId: loaivanbanvalue.id,
          coQuanBanHanhId: coquanbanhanhvalue.id,
          nguoiKy: nguoiky,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.id === vanban_id) {
            showNotification();
          } else showNotification3();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const Uploadnewfile = () => {
    setFileid([]);
    var url = Config.backend + "/api/QLVanBan/UploadFile?id=" + vanban_id;
    axios.post(url, fileupload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    showNotification1();
    setOpensua(true);
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  const showNotification3 = () => {
    setAlert3(true);
    setTimeout(function () {
      setAlert3(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (sokyhieu.trim() === "") {
      return Error.ER0025;
    }
    if (trichyeu.trim() === "") {
      return Error.ER0021;
    }
    // if (!loaiviphamvalue || loaiviphamvalue.id === 0) {
    //   return Error.ER0022;
    // }
    if (!loaivanbanvalue || loaivanbanvalue.id === 0) {
      return Error.ER0023;
    }
    if (!coquanbanhanhvalue || coquanbanhanhvalue.id == 0) {
      return Error.ER0024;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getvanbantheoid();
    //getloaivipham();
    getcoquanbanhanh();
    getloaivanban();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số ký hiệu"
                variant="outlined"
                size="small"
                value={sokyhieu}
                onChange={(event) => {
                  setSokyhieu(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày ban hành"
                  value={ngayvanban}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayvanban(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Trích yếu"
                variant="outlined"
                size="small"
                value={trichyeu}
                onChange={(event) => {
                  setTrichyeu(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          {/* <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={loaiviphamvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={loaivipham}
                getOptionLabel={(option) => option.ten || option.theloaivb}
                onChange={(event, value) => {
                  setLoaiviphamvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaiviphamvalue(null);
                  } else {
                    setLoaiviphamvalue(
                      loaivipham.find(({ ten }) => ten === newInputValue)
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại vi phạm"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem> */}
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={loaivanbanvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={loaivanban}
                getOptionLabel={(option) => option.ten || option.loaivb}
                onChange={(event, value) => {
                  setLoaivanbanvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaivanbanvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại văn bản"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={coquanbanhanhvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={coquanbanhanh}
                getOptionLabel={(option) => option.ten || option.coquanbanhanh}
                onChange={(event, value) => {
                  setCoquanbanhanhvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setCoquanbanhanhvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cơ quan ban hành"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Người ký"
                variant="outlined"
                size="small"
                value={nguoiky}
                onChange={(event) => {
                  setNguoiky(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <FormControl
              style={{ width: "99%", marginTop: "10px", marginLeft: "4px" }}
            >
              <div className="row my-3">
                <div className="col-8">
                  <label className="btn btn-default p-0">
                    <input type="file" multiple onChange={selectFiles} />
                  </label>
                </div>
                <div className="col-4">
                  <button
                    style={{ width: "70px", marginTop: 10 }}
                    disabled={!selectedFiles}
                    onClick={uploadFiles}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Listfileuploaded fileid={fileid} xoafile={xoafile} />
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={opensua}
              onClose={handleClosesua}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={6}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thực hiện thay đổi File thành công
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosesua} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <CardBody>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={2}
                          style={{ float: "right" }}
                        >
                          <FormControl
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={getvanbantheoid}
                            >
                              Xác nhận
                            </Button>
                          </FormControl>
                        </GridItem>
                      </CardBody>
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatvanban}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Upload file thành công"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa file thành công"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert3}
            closeNotification={() => setAlert3(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatvanban.propTypes = {
  vanban_id: PropTypes.number,
};
export default Capnhatvanban;
